import React, { useEffect, useState } from "react"
import _isEmpty from "lodash/isEmpty"
import {
  getInternalLinkTypeForFindStore,
  removeCharactersAfterNumber,
  sanitizeTextForAnalytics,
} from "@/utils/helper"
import Checkbox from "@/components/core/Checkbox/Checkbox"
import { getShortenedUrl } from "@/utils/location"
import MissingImage from "@/public/images/image-missing.png"

const StoreCard = ({
  data,
  store,
  staticTexts,
  findStoreDetails,
  findStoreCheckedId,
  isChecked,
  handleFindStoreCheck,
  isMobile,
  activeTab,
  FIRST_TAB,
}) => {
  const [entityIDURL, setEntityIDURL] = useState("")
  useEffect(() => {
    getShortenedUrl(
      findStoreDetails[removeCharactersAfterNumber(data?.EntityID)]
    ).then(res => {
      setEntityIDURL(res)
    })
  }, [data?.EntityID])
  const formatPhoneNumber = phoneNumberString => {
    let cleaned = ("" + phoneNumberString).replace(/\D/g, "")
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3]
    }
    return null
  }

  const getInternalLinkTypeBasedOnLink = type => {
    const internalLinkType = getInternalLinkTypeForFindStore(
      data.LocationName,
      data.Locality,
      data.StateLong
    )
    if (
      type === "store name" ||
      type === "book appointment" ||
      type === "view store details" ||
      type === "set as preferred store" ||
      type === "unset as preferred store"
    ) {
      return `find a store:${internalLinkType}`
    }
    return sanitizeTextForAnalytics(data.LocationName)
  }
  const getEventInfo = (type, link) => {
    return JSON.stringify({
      eventAction: "find a store:landing:map:" + type,
      eventName: "find a store:landing:map:" + type,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName:
        type === "store name"
          ? sanitizeTextForAnalytics(data.LocationName)
          : type === "store contact number"
          ? formatPhoneNumber(data.Phone)
          : type,
      internalLinkPosition: "find a store",
      internalLinkType: getInternalLinkTypeBasedOnLink(type),
      internalLinkURL: link
        ? (type !== "store contact number" && link.indexOf("http") === -1
            ? window.location.origin
            : "") + link
        : "n/a",
      internalLinkZoneName: "find a store:landing:map​",
      clickInternalLinks: "true",
    })
  }

  const isPreferredStore = findStoreCheckedId === data?.EntityID

  return (
    <div
      className={`store-card col-12 pr-0 ${
        !store && "showroom"
      } wow animate__fadeInUp`}
    >
      <div className="store-card__details">
        <div className="store-card__address">
          {store && data.LocationName.split("by")[1] ? (
            <a
              href={entityIDURL ?? "/"}
              className="store-card__name gbh-data-layer"
              data-gbh-data-layer={getEventInfo(
                "store name",
                findStoreDetails[removeCharactersAfterNumber(data?.EntityID)] ??
                  "/"
              )}
            >
              {" "}
              <p>{data.LocationName.split("by")[0]}</p>{" "}
              <span>by {data.LocationName.split("by")[1]}</span>{" "}
            </a>
          ) : (
            <span className="store-card__name">
              <p>{data.LocationName}</p>
            </span>
          )}
          <address>
            <p>{data.AddressLine + ","}</p>
            <p>{data?.AddressLine2 ? data?.AddressLine2 + "," : ""}</p>
            <p>
              {data.Locality}, {data.AdminDistrict} {data.PostalCode}
            </p>
          </address>
          {data?.Phone && (
            <p className="store-card-phone">
              <a
                href={`tel:${data.Phone}`}
                className="gbh-data-layer"
                data-gbh-data-layer={getEventInfo(
                  "store contact number",
                  `tel:${data.Phone}`
                )}
              >
                {staticTexts.ariaLabel.contact(formatPhoneNumber(data.Phone))}
              </a>
            </p>
          )}
        </div>
        {data?.__Distance && (
          <div className="store-card__time">
            <div className="store-card__open">
              <p className="distance">
                {data.__Distance?.toFixed(2)} {staticTexts.miles}{" "}
                {staticTexts.away}
              </p>
              <p>{data.WeekdayHours?.replaceAll(" - ", "-")}</p>
              <p>{data.WeekendHours}</p>
              {activeTab === FIRST_TAB && (
                <p>
                  <Checkbox
                    checked={isPreferredStore}
                    value={
                      isChecked && isPreferredStore
                        ? staticTexts.setAsMyShowroom
                        : staticTexts.setAsMyShowroom
                    }
                    id={"store-card__set-store"}
                    onChange={e =>
                      handleFindStoreCheck(
                        e.target.checked ? data?.EntityID : 0
                      )
                    }
                    analyticsData={getEventInfo(
                      (isPreferredStore ? "unset" : "set") +
                        " as preferred store"
                    )}
                  />
                </p>
              )}
            </div>
            {activeTab === FIRST_TAB && (
              <a
                href={entityIDURL ?? "/"}
                className="store-card__view-details gbh-data-layer"
                data-gbh-data-layer={getEventInfo("view store details")}
              >
                {isMobile
                  ? staticTexts.storeDetail
                  : staticTexts.viewShowroomDetails}
              </a>
            )}
          </div>
        )}
      </div>
      {(!store || !isMobile) && (
        <div className="store-card__image">
          <img
            onError={e => (e.target.src = MissingImage)}
            src={!_isEmpty(data.Image) ? data.Image : MissingImage?.src}
            alt={data?.AltText || staticTexts?.annsacksShowroomImgAlt}
          />
        </div>
      )}
    </div>
  )
}

export default StoreCard
